<mat-toolbar color="primary">
  <div mat-icon-button class="menu-button">
    <img src="assets/assist-logo.png" class="client-logo" alt="Tensor Logo">
  </div>
  <span class="toolbar-title">{{title}}</span>
  <span class="spacer"></span>
  <small class="toolbar-subtitle">{{subTitle}}</small>
  <app-theme-switcher *ngIf="showThemeSwitcher"></app-theme-switcher>

  <!-- Close button - only shown when embedded in iframe -->
  <button
    *ngIf="isEmbedded"
    mat-icon-button
    (click)="closeEmbeddedPortal()"
    class="close-button"
    aria-label="Close Patient Portal">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
